// Cầu nối frontend ↔ backend /students/gamification (lộ trình "vượt ải" + phần thưởng).
// Tái dùng bảng achievements: mỗi ải qua/huy hiệu = 1 dòng, cấp idempotent theo `key`.
import { API_CONFIG } from '../../../config/api.config'

const BASE = `${API_CONFIG.python.apiUrl}/students/gamification`

function getToken(): string {
  return (
    localStorage.getItem('jwt_token') ||
    localStorage.getItem('auth_token') ||
    localStorage.getItem('token') ||
    ''
  )
}

export function isAuthed(): boolean {
  return !!getToken()
}

export interface GamificationState {
  totalXp: number
  level: number
  xpInLevel: number
  xpForNextLevel: number
  badgesCount?: number
  badges?: any[]
}

export interface GrantPayload {
  key: string              // idempotent (vd: 'quest:<slug>:<sectionId>:<cardId>')
  type?: string            // 'lesson_quest' | 'badge'
  title: string
  description?: string
  icon?: string
  xp?: number
  stars?: number
  meta?: Record<string, any>
}

export interface GrantResult {
  granted: boolean
  totalXp: number
  level: number
  xpInLevel: number
  xpForNextLevel: number
}

export const gamificationApi = {
  // Cấp phần thưởng cho 1 ải/huy hiệu. Không đăng nhập → bỏ qua êm (vẫn có hiệu ứng phía client).
  async grant(payload: GrantPayload): Promise<GrantResult | null> {
    if (!isAuthed()) return null
    try {
      const res = await fetch(`${BASE}/grant`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
        body: JSON.stringify(payload),
        keepalive: true,
      })
      if (!res.ok) return null
      return await res.json()
    } catch {
      return null
    }
  },

  async me(): Promise<GamificationState | null> {
    if (!isAuthed()) return null
    try {
      const res = await fetch(`${BASE}/me`, {
        headers: { Authorization: `Bearer ${getToken()}` },
      })
      if (!res.ok) return null
      return await res.json()
    } catch {
      return null
    }
  },
}
